import React from 'react';
import { useTranslation } from 'react-i18next';
import circleBackgroundImage from './content-icon.svg';
import circleBackgroundImageDark from './content-icon-dark.svg';

interface IdentificationInfoContentProps {
  informationText?:
    | 'VerificationLandingPage.content'
    | 'VerificationLandingPage.tanDescription'
    | 'WebIdVerificationStartPage.body';
  translationValues?: Record<string, string | number>;
  isDarkModeOn?: boolean;
}

const IdentificationInfoContent: React.FC<IdentificationInfoContentProps> = ({
  informationText = 'VerificationLandingPage.content',
  translationValues = {},
  isDarkModeOn,
}) => {
  const { t } = useTranslation();

  return (
    <div className='grid-flex'>
      <div className='grid-item one-sixth grid-align-center'>
        <img
          src={isDarkModeOn ? circleBackgroundImageDark : circleBackgroundImage}
          alt='verification icon'
          height={66}
          width={64}
        />
      </div>
      <div className='grid-item four-fifth palm-padding-left-xl'>
        <p>{t(informationText, translationValues)}</p>
      </div>
    </div>
  );
};

export default IdentificationInfoContent;
